import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { auth } from '../services/api';
import toast from 'react-hot-toast';
import { CheckCircle2 } from 'lucide-react';

export default function ResetConfirmPage() {
  const { uid, token } = useParams();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error('Las contraseñas no coinciden.');
      return;
    }
    setLoading(true);
    try {
      await auth.resetConfirm({ uid, token, new_password: password });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Enlace inválido o expirado.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card animate-in">
        {done ? (
          <div style={{ textAlign: 'center' }}>
            <CheckCircle2 size={48} color="var(--success)" style={{ margin: '16px 0' }} />
            <h2>Contraseña restablecida</h2>
            <p style={{ color: 'var(--gray-500)', marginBottom: 20, marginTop: 8 }}>
              Ya puedes iniciar sesión con tu nueva contraseña.
            </p>
            <Link to="/login" className="btn btn--primary">Iniciar sesión</Link>
          </div>
        ) : (
          <>
            <h2>Nueva contraseña</h2>
            <p>Introduce tu nueva contraseña</p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nueva contraseña</label>
                <input
                  className="form-input"
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  minLength={8}
                  required
                />
              </div>
              <div className="form-group">
                <label>Confirmar contraseña</label>
                <input
                  className="form-input"
                  type="password"
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn--primary btn--lg" disabled={loading} style={{ width: '100%' }}>
                {loading ? 'Guardando...' : 'Restablecer contraseña'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
